import { useState, useEffect } from "react";
import "../../clients/ClientTable.css";

const ModePaiementTable = ({
  modes,
  onEdit,
  onDelete
}) => {

  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;



  // Reset pagination après recherche
  useEffect(() => {

    setCurrentPage(1);

  }, [search]);



  // Recherche

  const filteredModes = (modes || []).filter((mode) => {

    const q = search.toLowerCase();

    return (

      mode.nom?.toLowerCase().includes(q)

    );

  });



  const totalPages = Math.ceil(
    filteredModes.length / itemsPerPage
  ) || 1;



  const startIndex =
    (currentPage - 1) * itemsPerPage;



  const paginatedModes =
    filteredModes.slice(
      startIndex,
      startIndex + itemsPerPage
    );



  return (

    <div className="table-container">


      {/* Recherche */}

      <input

        type="text"

        placeholder="Rechercher un mode de paiement..."

        value={search}

        onChange={(e)=>
          setSearch(e.target.value)
        }

       style={{ padding: "8px", width: "100%", marginBottom: "15px" }}

      />



      {

        filteredModes.length === 0 ?


        (

          <p>
            Aucun mode de paiement trouvé
          </p>

        )


        :


        (

        <table className="responsive-table">

          <thead>

            <tr>

              <th>Nom</th>

              <th>Actions</th>

            </tr>

          </thead>



          <tbody>

          {

            paginatedModes.map((mode)=>(

              <tr key={mode.id}>


                <td data-label="Nom">

                  {mode.nom}

                </td>



                <td data-label="Actions">


                  <button

                    className="btn edit"

                    onClick={() =>
                      onEdit(mode)
                    }

                  >

                    ✏️

                  </button>



                  <button

                    className="btn delete"

                    onClick={() =>
                      onDelete(mode.id)
                    }

                  >

                    🗑

                  </button>


                </td>


              </tr>


            ))

          }

          </tbody>


        </table>

        )

      }





      {/* Pagination */}

      {

        totalPages > 1 &&


        <div className="pagination">


          <button

            disabled={currentPage === 1}

            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }

          >

            ◀

          </button>





          {

            Array.from(

              {length: totalPages},

              (_,i)=>(


                <button

                  key={i+1}

                  className={
                    currentPage === i+1
                    ? "active"
                    : ""
                  }


                  onClick={() =>
                    setCurrentPage(i+1)
                  }

                >

                  {i+1}

                </button>


              )

            )

          }





          <button

            disabled={
              currentPage === totalPages
            }

            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }

          >

            ▶

          </button>


        </div>

      }



    </div>

  );

};


export default ModePaiementTable;